// eslint-disable-next-line
import axios from "axios";
import { axiosInstance } from "./axiosInstance";
import { message } from "antd";

export const API = {
  pictures: {
    removeImage: (token, messageApi) => async (id) => {
      const msgApi = messageApi || message;
      return await axiosInstance
        .delete(`/pictures/${id}/?token=${token}`)
        .then(() => {
          if (messageApi) {
            msgApi.open({
              type: "success",
              content: "Изображение было удалено",
              duration: 3,
            });
          } else {
            msgApi.success("Изображение было удалено");
          }
        })
        .catch((err) => {
          const errorMessage =
            err?.response?.data?.message ||
            err?.response?.data?.detail ||
            err?.message ||
            "Ошибка при удалении изображения";
          if (messageApi) {
            msgApi.open({ type: "error", content: errorMessage, duration: 4 });
          } else {
            msgApi.error(errorMessage);
          }
          return Promise.reject(err);
        });
    },
  },
  crud: {
    create: (token, url, messageApi) => async (data) => {
      const msgApi = messageApi || message;
      return await axiosInstance
        .post(url, data, {
          params: { token },
        })
        .then((result) => {
          msgApi.success("Вы успешно создали строку");
          return result;
        })
        .catch((err) => {
          let errorMessage = "Ошибка при создании строки";

          if (err?.response?.status === 422) {
            const errorData = err.response?.data;
            if (errorData?.detail) {
              if (Array.isArray(errorData.detail)) {
                const errors = errorData.detail
                  .map((err) => {
                    if (typeof err === "string") return err;
                    if (err?.msg) {
                      const field = err.loc?.slice(1).join(".") || "поле";
                      return `${field}: ${err.msg}`;
                    }
                    return JSON.stringify(err);
                  })
                  .join("; ");
                errorMessage = errors;
              } else if (typeof errorData.detail === "string") {
                errorMessage = errorData.detail;
              } else {
                errorMessage = JSON.stringify(errorData.detail);
              }
            } else if (errorData?.message) {
              errorMessage = errorData.message;
            }
          } else {
            errorMessage =
              err?.response?.data?.message ||
              err?.response?.data?.detail ||
              err?.message ||
              "Ошибка при создании строки";
          }

          msgApi.error(errorMessage);
          return Promise.reject(err);
        });
    },
    edit: (token, url, messageApi) => async (data, id) => {
      const msgApi = messageApi || message;
      return await axiosInstance
        .patch(`${url}/${data.id || id}/`, data, {
          params: { token },
        })
        .then((result) => {
          if (messageApi) {
            msgApi.open({
              type: "success",
              content: "Строка была успешнo отредактирована",
              duration: 3,
            });
          } else {
            msgApi.success("Строка была успешнo отредактирована");
          }
          return result;
        })
        .catch((err) => {
          let errorMessage = "Ошибка при редактировании строки";

          if (err?.response?.status === 422) {
            const errorData = err.response?.data;
            if (errorData?.detail) {
              if (Array.isArray(errorData.detail)) {
                const errors = errorData.detail
                  .map((err) => {
                    if (typeof err === "string") return err;
                    if (err?.msg) {
                      const field = err.loc?.slice(1).join(".") || "поле";
                      return `${field}: ${err.msg}`;
                    }
                    return JSON.stringify(err);
                  })
                  .join("; ");
                errorMessage = errors;
              } else if (typeof errorData.detail === "string") {
                errorMessage = errorData.detail;
              } else {
                errorMessage = JSON.stringify(errorData.detail);
              }
            } else if (errorData?.message) {
              errorMessage = errorData.message;
            }
          } else {
            errorMessage =
              err?.response?.data?.message ||
              err?.response?.data?.detail ||
              err?.message ||
              "Ошибка при редактировании строки";
          }

          if (messageApi) {
            msgApi.open({ type: "error", content: errorMessage, duration: 4 });
          } else {
            msgApi.error(errorMessage);
          }
          return Promise.reject(err);
        });
    },
    editTwo: (token, url, messageApi) => async (data) => {
      const msgApi = messageApi || message;
      return await axiosInstance
        .patch(url, data, {
          params: { token },
        })
        .then((result) => {
          msgApi.success("Строка была успешнo отредактирована");
          return result;
        })
        .catch((err) => {
          let errorMessage = "Ошибка при редактировании строки";

          if (err?.response?.status === 422) {
            const errorData = err.response?.data;
            if (errorData?.detail) {
              if (Array.isArray(errorData.detail)) {
                const errors = errorData.detail
                  .map((err) => {
                    if (typeof err === "string") return err;
                    if (err?.msg) {
                      const field = err.loc?.slice(1).join(".") || "поле";
                      return `${field}: ${err.msg}`;
                    }
                    return JSON.stringify(err);
                  })
                  .join("; ");
                errorMessage = errors;
              } else if (typeof errorData.detail === "string") {
                errorMessage = errorData.detail;
              } else {
                errorMessage = JSON.stringify(errorData.detail);
              }
            } else if (errorData?.message) {
              errorMessage = errorData.message;
            }
          } else {
            errorMessage =
              err?.response?.data?.message ||
              err?.response?.data?.detail ||
              err?.message ||
              "Ошибка при редактировании строки";
          }

          msgApi.error(errorMessage);
          return Promise.reject(err);
        });
    },
    remove: (token, url, messageApi) => async (id, data) => {
      const msgApi = messageApi || message;
      return await axiosInstance
        .delete(
          `${url}/${id}/?token=${token}`,
          !!data ? { data: data } : undefined,
        )
        .then(() => {
          if (messageApi) {
            msgApi.open({
              type: "success",
              content: "Строка была успешно удалена",
              duration: 3,
            });
          } else {
            msgApi.success("Строка была успешно удалена");
          }
        })
        .catch((err) => {
          const errorMessage =
            err?.response?.data?.message ||
            err?.response?.data?.detail ||
            err?.message ||
            "Ошибка при удалении строки";
          if (messageApi) {
            msgApi.open({ type: "error", content: errorMessage, duration: 4 });
          } else {
            msgApi.error(errorMessage);
          }
          return Promise.reject(err);
        });
    },
    get: (token, url) => async (id, params) =>
      await axiosInstance
        .get(`${url}/${id || ""}/?token=${token}`, { params: params || "" })
        .then((item) => item.data)
        .catch((err) => Promise.reject(err)),
  },
  search: (token, url) => async (params) =>
    await axiosInstance
      .get(`${url}/?token=${token}`, { params: params })
      .then((item) => item.data)
      .catch((err) => Promise.reject(err)),
};

class APIRequests {
  token;

  constructor() {
    axiosInstance.interceptors.request.use((config) => {
      if (this.token) {
        config.params = {
          ...(config.params || {}),
          token: this.token,
        };
      }
      return config;
    });
  }

  setToken(token) {
    this.token = token;
    if (!token) {
      console.warn(
        "APIRequests: Token is not set! Requests may fail with 403.",
      );
    }
  }

  feeds = {
    getItems: (params = {}) => {
      return axiosInstance.get("/feeds/", { params });
    },
    getItem: (id) => {
      return axiosInstance.get(`/feeds/${id}/`);
    },
    post: (payload) => {
      return axiosInstance.post("/feeds/", payload);
    },
    patch: (id, payload) => {
      return axiosInstance.patch(`/feeds/${id}/`, payload);
    },
    delete: (id) => {
      return axiosInstance.delete(`/feeds/${id}/`);
    },
    getFeedByToken: (url_token) => {
      return axiosInstance.get(`/feeds/${url_token}/`);
    },
    getFeedXml: (url_token) => {
      return axiosInstance.get(`/feeds/${url_token}/`, {
        headers: { Accept: "application/xml" },
      });
    },
  };

  account = {
    getInfo: (params = {}) => {
      return axiosInstance.get("/account/info/", params);
    },
    getTariffs: (params = {}) => {
      return axiosInstance.get("/tariffs/", params);
    },
    createPayment: (payload) => {
      return axiosInstance.post("/transactions/payment/create", payload);
    },
    createManualDeposit: (payload, adminId) => {
      return axiosInstance.post(
        `/transactions/deposit?admin=${adminId}`,
        payload,
      );
    },
  };

  integrationCdek = {
    check: (token) => {
      return axiosInstance.get("/cdek/check", { params: { token } });
    },
    integrationOn: (token) => {
      return axiosInstance.get("/cdek/integration_on", { params: { token } });
    },
    integrationOff: (token) => {
      return axiosInstance.get("/cdek/integration_off", { params: { token } });
    },
    calculate: (payload, token) => {
      return axiosInstance.post("/cdek/calculate", payload, {
        params: { token },
      });
    },
    createOrder: (payload, token) => {
      return axiosInstance.post("/cdek/order", payload, { params: { token } });
    },
    getOrder: (uuid, token) => {
      return axiosInstance.get(`/cdek/order/${uuid}`, { params: { token } });
    },
    getDeliveryPoints: (params, token) => {
      return axiosInstance.get("/cdek/delivery-points", {
        params: { token, ...params },
      });
    },
    printWaybill: (payload, token) => {
      return axiosInstance.post("/cdek/print/waybill", payload, {
        params: { token },
      });
    },
    printBarcode: (payload, token) => {
      return axiosInstance.post("/cdek/print/barcode", payload, {
        params: { token },
      });
    },
    getOrders: (params, token) => {
      return axiosInstance.get("/cdek/orders", {
        params: { token, ...params },
      });
    },
    getTariffs: (token) => {
      return axiosInstance.get("/cdek/tariffs", { params: { token } });
    },
    lkLogin: (payload) => {
      return axiosInstance.post("/cdek/lk/login", payload);
    },
    lkProfile: (payload) => {
      return axiosInstance.post("/cdek/lk/profile", payload);
    },
    suggestCities: (params, token) => {
      return axiosInstance.get("/cdek/suggest-cities", {
        params: { token, ...params },
      });
    },
    lkSession: (token) => {
      return axiosInstance.get("/cdek/lk/session", { params: { token } });
    },
    lkLogout: (token) => {
      return axiosInstance.post("/cdek/lk/logout", null, { params: { token } });
    },
    getTemplate: (token) => {
      return axiosInstance.get("/cdek/template", { params: { token } });
    },
    saveTemplate: (template, token) => {
      return axiosInstance.post("/cdek/template", template, {
        params: { token },
      });
    },
    addressSuggestions: (payload, token) => {
      return axiosInstance.post("/cdek/address-suggestions", payload, {
        params: { token },
      });
    },
    getOrderInfo: (order_uuid, token) => {
      return axiosInstance.get(`/cdek/order/${order_uuid}`, {
        params: { token },
      });
    },
    linkOrderToSales: (orderUuid, docSalesId, token) => {
      return axiosInstance.patch(
        `/cdek/order/${orderUuid}/link-sales`,
        { doc_sales_id: docSalesId },
        { params: { token } },
      );
    },
    deleteOrder: (orderUuid, token) => {
      return axiosInstance.delete(`/cdek/order/${orderUuid}`, {
        params: { token },
      });
    },
    getOrderByDoc: (docSalesId, token) => {
      return axiosInstance.get(`/cdek/order/by-doc/${docSalesId}`, {
        params: { token },
      });
    },

    getWaybillInfo: (uuid, token) => {
      return axiosInstance.get(`/cdek/print/waybill/${uuid}`, {
        params: { token },
      });
    },

    downloadWaybill: (uuid, token) => {
      return axiosInstance.get(`/cdek/print/waybill/${uuid}/download`, {
        params: { token },
        responseType: "blob",
      });
    },

    getBarcodeInfo: (uuid, token) => {
      return axiosInstance.get(`/cdek/print/barcode/${uuid}`, {
        params: { token },
      });
    },

    downloadBarcode: (uuid, token) => {
      return axiosInstance.get(`/cdek/print/barcode/${uuid}/download`, {
        params: { token },
        responseType: "blob",
      });
    },
    getIntegrationKeys: (token) => {
      return axiosInstance.post("/cdek/lk/integration-keys", null, {
        params: { token },
      });
    },
    autoRegisterWebhooks: (token) => {
      return axiosInstance.post("/cdek/webhooks/auto-register", null, {
        params: { token },
      });
    },
    getWebhookStatus: (token) => {
      return axiosInstance.get("/cdek/webhooks/status", { params: { token } });
    },
  };

  nomenclatureVideos = {
    getItems: (nomenclatureId, params = {}) => {
      return axiosInstance.get(`/nomenclature/${nomenclatureId}/videos`, {
        params,
      });
    },
    createItem: (nomenclatureId, payload, params = {}) => {
      return axiosInstance.post(
        `/nomenclature/${nomenclatureId}/videos`,
        payload,
        { params },
      );
    },
    patchItem: (videoId, payload, params = {}) => {
      return axiosInstance.patch(`/nomenclature/videos/${videoId}`, payload, {
        params,
      });
    },
    deleteItem: (videoId, params = {}) => {
      return axiosInstance.delete(`/nomenclature/videos/${videoId}`, {
        params,
      });
    },
  };

  articles = {
    getItem: (id) => {
      return axiosInstance.get(`/articles/${id}/`);
    },
    post: (payload) => {
      return axiosInstance.post(`/articles/`, payload);
    },
    put: (id, payload) => {
      return axiosInstance.put(`/articles/${id}/`, payload);
    },
  };
  payments = {
    getMeta: (params = {}) => {
      return axiosInstance.get(`/payments_meta/`, {
        params,
      });
    },
    getItems: (params = {}) => {
      return axiosInstance.get(`/payments/`, {
        params,
      });
    },
    post: (payload) => {
      return axiosInstance.post(`/payments/`, payload);
    },
    put: (id, payload) => {
      return axiosInstance.put(`/payments/${id}/`, payload);
    },
    delete: (id, payload) => {
      return axiosInstance.delete(`/payments/${id}/`, payload);
    },
  };

  projects = {
    getItems: (params = {}) => {
      return axiosInstance.get("/projects/", { params });
    },
    post: (payload) => {
      return axiosInstance.post(`/projects/`, payload);
    },
    put: (payload) => {
      return axiosInstance.put(`/projects/`, payload);
    },
  };

  payboxes = {
    getItems: (params = {}) => {
      return axiosInstance.get("/payboxes/", { params });
    },
    post: (payload) => {
      return axiosInstance.post("/payboxes/", payload);
    },
    put: (payload) => {
      return axiosInstance.put("/payboxes/", payload);
    },
  };

  cashboxes = {
    getMeta: (params = {}) => {
      return axiosInstance.get("/cashboxes_meta/", { params });
    },
  };

  chats = {
    getChannels: (params = {}) => {
      return axiosInstance.get("/chats/channels/", { params });
    },
    createChannel: (payload) => {
      return axiosInstance.post("/chats/channels/", payload);
    },
    getChannel: (channelId) => {
      return axiosInstance.get(`/chats/channels/${channelId}`);
    },
    updateChannel: (channelId, payload) => {
      return axiosInstance.put(`/chats/channels/${channelId}`, payload);
    },
    deleteChannel: (channelId) => {
      return axiosInstance.delete(`/chats/channels/${channelId}`);
    },

    getChats: (params = {}) => {
      return axiosInstance.get("/chats/chats/", { params });
    },
    createChat: (payload) => {
      return axiosInstance.post("/chats/chats/", payload);
    },
    getChat: (chatId) => {
      return axiosInstance.get(`/chats/chats/${chatId}`);
    },
    updateChat: (chatId, payload) => {
      return axiosInstance.put(`/chats/chats/${chatId}`, payload);
    },
    deleteChat: (chatId) => {
      return axiosInstance.delete(`/chats/chats/${chatId}`);
    },
    getChatFiles: (chatId, params = {}) => {
      return axiosInstance.get(`/chats/chats/${chatId}/files/`, { params });
    },
    getManagersInChat: (chatId) => {
      return axiosInstance.get(`/chats/chats/${chatId}/managers/`);
    },
    chainClient: (chatId, payload = {}) => {
      return axiosInstance.post(
        `/chats/chats/${chatId}/chain_client/`,
        payload,
      );
    },

    createMessage: (payload) => {
      return axiosInstance.post("/chats/messages/", payload);
    },
    getMessage: (messageId) => {
      return axiosInstance.get(`/chats/messages/${messageId}`);
    },
    deleteMessage: (messageId) => {
      return axiosInstance.delete(`/chats/messages/${messageId}`);
    },
    getChatMessages: (chatId, params = {}) => {
      return axiosInstance.get(`/chats/messages/chat/${chatId}`, { params });
    },
    getMessageFiles: (messageId) => {
      return axiosInstance.get(`/chats/messages/${messageId}/files/`);
    },
    uploadChatFile: (chatId, formData, onUploadProgress) => {
      return axiosInstance.post(`/chats/upload?chat_id=${chatId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress,
      });
    },
    markChatAsRead: (chatId, params = {}) => {
      return axiosInstance.post(
        `/chats/avito/chats/${chatId}/mark-read`,
        {},
        { params },
      );
    },
    getLink: () => {
      return axiosInstance.post(`/chats/telegram/invite-link`);
    },
    connectTelegram: (data) =>
      axiosInstance.post(`/chats/telegram/connect`, data),
  };

  categories = {
    getItems: (params = {}) => {
      return axiosInstance.get("/categories/", { params });
    },
    getItem: (id, params = {}) => {
      return axiosInstance.get(`/categories/${id}/`, { params });
    },
    post: (payload) => {
      return axiosInstance.post("/categories/", payload);
    },
  };

  tech_cards = {
    getItems: (params = {}) => {
      return axiosInstance.get(`/tech_cards/`, { params });
    },
    getItem: (id, params = {}) => {
      return axiosInstance.get(`/tech_cards/${id}/`, { params });
    },
    post: (payload) => {
      return axiosInstance.post(`/tech_cards/`, payload);
    },
    put: (id, payload) => {
      return axiosInstance.put(`/tech_cards/${id}/`, payload);
    },
    delete: (id) => {
      return axiosInstance.delete(`/tech_cards/${id}/`);
    },
  };

  tech_operations = {
    getItems: (params = {}) => axiosInstance.get(`/tech_operations/`, { params }),
    getItem: (id, params = {}) => axiosInstance.get(`/tech_operations/${id}/`, { params }),
    create: (payload) => axiosInstance.post(`/tech_operations/`, payload),
    reverse: (id, payload = {}) => axiosInstance.post(`/tech_operations/${id}/reverse`, payload),
    cancel: (id, payload = {}) => axiosInstance.post(`/tech_operations/${id}/cancel`, payload),
    delete: (id) => axiosInstance.delete(`/tech_operations/${id}/`),
  };

  contragents = {
    getItems: (params = {}) => {
      return axiosInstance.get("/contragents/", { params });
    },
    getItem: (id) => {
      return axiosInstance.get(`/contragents/${id}/`);
    },
    post: (payload) => {
      return axiosInstance.post("/contragents/", payload);
    },
    put: (id, payload) => {
      return axiosInstance.put(`/contragents/${id}/`, payload);
    },
    delete: (id, payload) => {
      return axiosInstance.delete(`/contragents/${id}/`, payload);
    },
  };

  loyalityCards = {
    getItems: (params = {}) => {
      return axiosInstance.get("/loyality_cards/", { params });
    },
    post: (payload) => {
      return axiosInstance.post("/loyality_cards/", payload);
    },
    patch: (id, payload) => {
      return axiosInstance.patch(`/loyality_cards/${id}/`, payload);
    },
    delete: (id, payload) => {
      return axiosInstance.delete(`/loyality_cards/${id}/`, payload);
    },
    getById: (id) => {
      return axiosInstance.get(`/loyality_cards/${id}/`);
    },
  };

  loyalityTransactions = {
    getItems: (params = {}) => {
      return axiosInstance.get("/loyality_transactions/", { params });
    },
    post: (payload) => {
      return axiosInstance.post("/loyality_transactions/", payload);
    },
    patch: (id, payload) => {
      return axiosInstance.patch(`/loyality_transactions/${id}/`, payload);
    },
    delete: (id, payload) => {
      return axiosInstance.delete(`/loyality_transactions/${id}/`, payload);
    },
  };
  loyalitySettings = {
    getItems: (params = {}) => {
      return axiosInstance.get("/loyality_settings/", { params });
    },
    // сигнатура как у crud.remove
    remove: (token, url, messageApi) => async (id, data) => {
      const msgApi = messageApi || message;
      return await axiosInstance
        .delete(
          `/loyality_settings/?token=${token}&$organization_id={id}`,
          !!data ? { data: data } : undefined,
        )
        .then(() => {
          if (messageApi) {
            msgApi.open({
              type: "success",
              content: "Строка была успешно удалена",
              duration: 3,
            });
          } else {
            msgApi.success("Строка была успешно удалена");
          }
        })
        .catch((err) => {
          const errorMessage =
            err?.response?.data?.message ||
            err?.response?.data?.detail ||
            err?.message ||
            "Ошибка при удалении строки";
          if (messageApi) {
            msgApi.open({ type: "error", content: errorMessage, duration: 4 });
          } else {
            msgApi.error(errorMessage);
          }
          return Promise.reject(err);
        });
    },
  };
  contracts = {
    getItems: (params = {}) => {
      return axiosInstance.get("/contracts/", { params });
    },
  };
  organizations = {
    getItems: (params = {}) => {
      return axiosInstance.get("/organizations/", { params });
    },
  };
  warehouses = {
    getItems: (params = {}) => {
      return axiosInstance.get("/warehouses/", { params });
    },
    getBalances: (id, params = {}) => {
      return axiosInstance.get(`/warehouses/${id}/`, { params });
    },
  };
  nomenclature = {
    getItems: (params = {}) => {
      return axiosInstance.get(`/nomenclature/`, { params });
    },
    getItem: (id, params = {}) => {
      return axiosInstance.get(`/nomenclature/${id}/`, { params });
    },
    post: (payload) => {
      return axiosInstance.post(`/nomenclature/`, payload);
    },
    patch: (payload) => {
      return axiosInstance.patch(`/nomenclature/`, payload);
    },
    delete: (payload) => {
      return axiosInstance.delete(`/nomenclature/`, payload);
    },
  };
  promocodes = {
    getItems: (params = {}) => {
      return axiosInstance.get("/promocodes/", { params });
    },
    getItem: (id) => {
      return axiosInstance.get(`/promocodes/${id}/`);
    },
    create: (payload) => {
      return axiosInstance.post("/promocodes/", payload);
    },
    update: (id, payload) => {
      return axiosInstance.patch(`/promocodes/${id}/`, payload);
    },
    delete: (id) => {
      return axiosInstance.delete(`/promocodes/${id}/`);
    },
    run: (payload) => {
      return axiosInstance.post("/promocodes/run/", payload);
    },
  };
  prices = {
    getItems: (params = {}) => {
      return axiosInstance.get(`/prices/`, { params });
    },
    getItem: (id, params = {}) => {
      return axiosInstance.get(`/prices/${id}/`, { params });
    },
    getAltItem: (id, params = {}) => {
      return axiosInstance.get(`/alt_prices/${id}/`, { params });
    },
    getTypes: (params = {}) => {
      return axiosInstance.get(`/price_types/`, { params });
    },
    post: (payload) => {
      return axiosInstance.post(`/prices/`, payload);
    },
    patch: (payload) => {
      // Если payload содержит id, используем PATCH /prices/{id}/
      // Иначе используем PATCH /prices/ (для массового обновления)
      if (payload?.id) {
        const { id, ...data } = payload;
        return axiosInstance.patch(`/prices/${id}/`, data);
      }
      return axiosInstance.patch(`/prices/`, payload);
    },
    delete: (payload) => {
      return axiosInstance.delete(`/prices/`, payload);
    },
  };
  priceTypes = {
    getItems: (payload) => {
      return axiosInstance.get("/price_types/", payload);
    },
  };
  pictures = {
    getItems: (params = {}) => {
      return axiosInstance.get(`/pictures/`, { params });
    },
    postPictureOrder: (entity, entityId, token, payload) => {
      // Если payload - это FormData, устанавливаем правильный Content-Type
      const config =
        payload instanceof FormData
          ? { headers: { "Content-Type": "multipart/form-data" } }
          : {};
      return axiosInstance.post(
        `/pictures/?entity=${entity}&entity_id=${entityId}&token=${token}`,
        payload,
        config,
      );
    },
    getItemsOrder: (entity, entityId, token) => {
      return axiosInstance.get(
        `/pictures/?entity=${entity}&entity_id=${entityId}&token=${token}`,
      );
    },
    deleteOrder: (id, token) => {
      return axiosInstance.delete(`/pictures/${id}/?token=${token}`);
    },
  };
  manufacturers = {
    getItems: (params = {}) => {
      return axiosInstance.get(`/manufacturers/`, { params });
    },
  };
  units = {
    getItems: (params = {}) => {
      return axiosInstance.get(`/units/`, { params });
    },
  };
  docs = {
    warehouse: (params = {}) => {
      return axiosInstance.get(`/docs_warehouse/`, { params });
    },
    deleteWarehouse: (payload) => {
      return axiosInstance.delete(`/docs_warehouse/${payload}`);
    },
    purchases: (params = {}) => {
      return axiosInstance.get(`/docs_purchases/`, { params });
    },
    postPurchases: (payload) => {
      return axiosInstance.post(`/docs_purchases/`, payload);
    },
    patchPurchases: (payload) => {
      return axiosInstance.patch(`/docs_purchases/`, payload);
    },
    patchPurchase: (id, payload) => {
      return axiosInstance.patch(`/docs_purchases/${id}/`, payload);
    },
    deletePurchase: (id, payload) => {
      return axiosInstance.delete(`/docs_purchases/${id}/`, payload);
    },
    purchasesItem: (id, params = {}) => {
      return axiosInstance.get(`/docs_purchases/${id}/`, { params });
    },
    sales: (params = {}) => {
      return axiosInstance.get(`/docs_sales/`, { params });
    },
    patchSales: (id, payload) => {
      return axiosInstance.patch(`/docs_sales/${id}/`, payload);
    },
    salesItem: (id, params = {}) => {
      return axiosInstance.get(`/docs_sales/${id}/`, { params });
    },
    postSales: (payload) => {
      return axiosInstance.post(`/docs_sales/`, payload);
    },
    postSalesDeliveryInfo: (id, params = {}) => {
      return axiosInstance.post(`/docs_sales/${id}/delivery_info/`, params);
    },
    getSalesLinks: (id) => {
      return axiosInstance.get(`/docs_sales/${id}/links/`);
    },
  };

  altDocs = {
    postWarehouse: (payload) => {
      return axiosInstance.post("/alt_docs_warehouse/", payload);
    },
    patchWarehouse: (payload) => {
      return axiosInstance.patch("/alt_docs_warehouse/", payload);
    },
  };

  users = {
    getItems: (params = {}) => {
      return axiosInstance.get("/cashbox_users/", { params });
    },
    put: (params = {}, user_id) => {
      return axiosInstance.put(`/cashbox_users/?user_id=${user_id}`, params);
    },
    getPermissions: (userId) => {
      return axiosInstance.get(`/users/permissions/${userId}`);
    },
    getMyPermissions: () => {
      return axiosInstance.get(`/users/permissions/me/`);
    },
    setPermissions: (userId, permissions) => {
      return axiosInstance.post(`/users/permissions/`, {
        user_id: userId,
        permissions: permissions,
      });
    },
    patchShiftSettings: (user_id, body = {}) => {
      return axiosInstance.patch(`/users/${user_id}/shift-settings`, body);
    },
  };

  analytics = {
    getCards: (params = {}) => {
      return axiosInstance.get("/analytics_cards/", { params });
    },
  };
  integrationPair = {
    getItems: (params = {}) => {
      return axiosInstance.get("/integration_pair/", { params });
    },
  };

  integrationTochka = {
    getLink: (params = {}) => {
      return axiosInstance.get("/bank/get_oauth_link/", { params });
    },
    getIntegrationOn: (params = {}) => {
      return axiosInstance.get("/bank/integration_on", { params });
    },
    getIntegrationOff: (params = {}) => {
      return axiosInstance.get("/bank/integration_off", { params });
    },
    getIntegrationCheck: (params = {}) => {
      return axiosInstance.get("/bank/check", { params });
    },
    getIntegrationAccounts: (params = {}) => {
      return axiosInstance.get("/bank/accounts/", { params });
    },
    patchIntegrationAccount: (id, payload) => {
      return axiosInstance.patch(`/bank/accounts/update/${id}/`, payload);
    },
  };
  integrationModule = {
    getLink: (params = {}) => {
      return axiosInstance.get("/module_bank/get_oauth_link/", { params });
    },
    getBills: (params = {}) => {
      return axiosInstance.get("/module_bank/accounts/", { params });
    },
    getIntegrationOn: (params = {}) => {
      return axiosInstance.get("/module_bank/integration_on", { params });
    },
    getIntegrationOff: (params = {}) => {
      return axiosInstance.get("/module_bank/integration_off", { params });
    },
    getIntegrationCheck: (params = {}) => {
      return axiosInstance.get("/module_bank/check", { params });
    },
    getIntegrationAccounts: (params = {}) => {
      return axiosInstance.get("/bank/accounts/", { params });
    },
    patchIntegrationAccount: (id, payload) => {
      return axiosInstance.patch(`/bank/accounts/update/${id}/`, payload);
    },
  };
  integrationEvotor = {
    getIntegrationOn: (params = {}) => {
      return axiosInstance.get("/evotor/integration/on", { params });
    },
    getIntegrationOff: (params = {}) => {
      return axiosInstance.get("/evotor/integration/off", { params });
    },
    getIntegrationInstall: (params = {}) => {
      return axiosInstance.get("/evotor/integration/install", { params });
    },
    getIntegrationCheck: (params = {}) => {
      return axiosInstance.get("/evotor/integration/check", { params });
    },
  };

  reports = {
    getSalesBalances: (payload) => {
      return axiosInstance.post("/reports/balances/", payload);
    },
    getSalesReport: (payload) => {
      return axiosInstance.post("/reports/sales/", payload);
    },
  };

  booking = {
    getItems: (params = {}) => {
      return axiosInstance.get("/booking/list/", { params });
    },
    getItemById: (id, params = {}) => {
      return axiosInstance.get(`/booking/${id}/`, { params });
    },
    post: (payload) => {
      return axiosInstance.post(`/booking/create`, payload);
    },
    patch: (payload) => {
      return axiosInstance.patch(`/booking/edit/`, payload);
    },
    getEventsByNomenclature: (id, params = {}) => {
      return axiosInstance.get(`/booking/events/nomenclature/${id}`, {
        params,
      });
    },
    delete: (id, params = {}) => {
      return axiosInstance.delete(`/booking/${id}/`, { params });
    },
  };
  clearQuantityBalance = {
    getClearCategory: (id, params = {}) => {
      return axiosInstance.get(
        `/warehouse_balances/clearQuantity/category/${id}`,
        { params },
      );
    },
    getClearProduct: (id, params = {}) => {
      return axiosInstance.get(
        `/warehouse_balances/clearQuantity/product/${id}`,
        { params },
      );
    },
  };
  triggers = {
    getItems: (params = {}) => {
      return axiosInstance.get("/settings/triggers", { params });
    },
    getItemById: (id, params = {}) => {
      return axiosInstance.get(`/settings/triggers/${id}`, { params });
    },
    post: (payload) => {
      return axiosInstance.post(`/settings/triggers`, payload);
    },
    patch: (id, payload) => {
      return axiosInstance.patch(`/settings/triggers/${id}`, payload);
    },
    deleteItem: (id, payload) => {
      return axiosInstance.delete(`/settings/triggers/${id}`, payload);
    },
  };
  amo_bots = {
    getItemsByName: (params = {}) => {
      return axiosInstance.get("/settings/amo_bots", { params });
    },
    getItemById: (id, params = {}) => {
      return axiosInstance.get(`/settings/amo_bots/${id}`, { params });
    },
  };
  integrationYookassa = {
    getIntegrationInstall: (params = {}) => {
      return axiosInstance.get("/yookassa/install", { params });
    },
    getIntegrationInstallList: (params = {}) => {
      return axiosInstance.get("/yookassa/install/list", { params });
    },
    getRevokeInstall: (params = {}) => {
      return axiosInstance.get("/yookassa/revoke", { params });
    },
    createPayment: (payload) => {
      return axiosInstance.post(`/yookassa/payments`, payload);
    },
    getPaymentByDocsSales: (doc_sales_id, params = {}) => {
      return axiosInstance.get(
        `/yookassa/payments/from_sales?doc_sales_id=${doc_sales_id}`,
        { params },
      );
    },
    getMe: (warehouse, params = {}) => {
      return axiosInstance.get(`/yookassa/me?warehouse=${warehouse}`, {
        params,
      });
    },
  };
  segments = {
    getData: (params = {}) => {
      return axiosInstance.get(`/segments/`, { params });
    },
    postData: (payload) => {
      return axiosInstance.post(`/segments/`, payload);
    },
    getById: (id) => {
      return axiosInstance.get(`/segments/${id}/result/`);
    },
    putData: (id, payload) => {
      return axiosInstance.put(`/segments/${id}/`, payload);
    },
    deleteData: (id) => {
      return axiosInstance.delete(`/segments/${id}/`);
    },

    getTags: (segmentId) => {
      return axiosInstance.get(`/segments/${segmentId}/tags/`);
    },
    addTags: (segmentId, tagsBody) => {
      return axiosInstance.post(`/segments/${segmentId}/tags/`, tagsBody);
    },
    removeTags: (segmentId, tagsBody) => {
      return axiosInstance.delete(`/segments/${segmentId}/tags/`, {
        data: tagsBody,
      });
    },
  };

  shifts = {
    startShift: (data = {}) =>
      axiosInstance.post("/employee-shifts/start", data),

    endShift: (data = {}) => axiosInstance.post("/employee-shifts/end", data),

    createBreak: (data = {}) =>
      axiosInstance.post("/employee-shifts/break", null, { params: data }),

    endBreak: () => axiosInstance.post("/employee-shifts/break/end", null),

    getStatus: () => axiosInstance.get("/employee-shifts/status"),

    // getListWithShifts: (name = undefined, limit = 100, offset = 0) => {
    //   return axiosInstance.get(`/employee-shifts/list-with-shifts`);
    // },

    getListWithShifts: (name = undefined, limit = 100, offset = 0) => {
      return axiosInstance.get("/employee-shifts/list-with-shifts/", {
        params: { name, limit, offset },
      });
    },

    getShiftEvents: (limit = 30, offset = 0) =>
      axiosInstance.get("/employee-shifts/get_shifts_events", {
        params: { limit, offset },
      }),
  };

  apple_card_settings = {
    get_settings: () => axiosInstance.get("/apple_wallet_card_settings"),
    patch_settings: (params = {}) =>
      axiosInstance.patch(`/apple_wallet_card_settings`, params),
    upload_file: (file) => {
      const formData = new FormData();
      formData.append("file", file);
      return axiosInstance.post(
        "/apple_wallet_card_settings/upload",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );
    },
    get_link_to_card: (card_id) => {
      return axiosInstance.get(`/link_to_card`, {
        params: { card_id },
      });
    },
  };

  avito = {
    connect: (payload) => {
      return axiosInstance.post("/chats/avito/connect", payload);
    },
    disconnect: (channelId, params = {}) => {
      return axiosInstance.delete(`/chats/avito/channels/${channelId}`, {
        params,
      });
    },
    loadHistory: (params = {}) => {
      return axiosInstance.post("/chats/avito/history/load", null, { params });
    },
  };

  commerceml = {
    getConnections: (token, params = {}) => {
      return axiosInstance.get("/commerceml/connections", {
        params: { token, ...params },
      });
    },
    getConnection: (id, token) => {
      return axiosInstance.get(`/commerceml/connections/${id}`, {
        params: { token },
      });
    },
    createConnection: (payload, token) => {
      return axiosInstance.post("/commerceml/connections", payload, {
        params: { token },
      });
    },
    updateConnection: (id, payload, token) => {
      return axiosInstance.patch(`/commerceml/connections/${id}`, payload, {
        params: { token },
      });
    },
    deleteConnection: (id, token) => {
      return axiosInstance.delete(`/commerceml/connections/${id}`, {
        params: { token },
      });
    },
    syncConnection: (id, type = "catalog", token) => {
      return axiosInstance.post(`/commerceml/connections/${id}/sync`, null, {
        params: { type, token },
      });
    },
    resetPassword: (id, newPassword = null, token) => {
      const body = newPassword != null ? { password: newPassword } : {};
      return axiosInstance.post(
        `/commerceml/connections/${id}/reset-password`,
        body,
        { params: { token } },
      );
    },
  };
}

export const apiRequests = new APIRequests();
